import { render, staticRenderFns } from "./bayWindow.vue?vue&type=template&id=15d2d93c&scoped=true"
import script from "./bayWindow.vue?vue&type=script&lang=js"
export * from "./bayWindow.vue?vue&type=script&lang=js"
import style0 from "./bayWindow.vue?vue&type=style&index=0&id=15d2d93c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15d2d93c",
  null
  
)

export default component.exports